import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { initLenis, scrollToTop } from "@/lib/lenis";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import Lavori from "@/pages/Lavori";
import ProjectDetail from "@/pages/ProjectDetail";
import ChiSiamo from "@/pages/ChiSiamo";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";
import Admin from "@/pages/Admin";
import Preventivo from "@/pages/Preventivo";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    initLenis();
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return (
    <div className="bg-white font-body text-slate-900">
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servizi" element={<Servizi />} />
        <Route path="/lavori" element={<Lavori />} />
        <Route path="/lavori/:id" element={<ProjectDetail />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/recensioni" element={<Recensioni />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/preventivo" element={<Preventivo />} />
      </Routes>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Toaster theme="light" position="top-center" richColors />
        <Shell />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
